import React from 'react';
import { Button, TextField } from '@mui/material';
import { Typography } from '@material-ui/core';
import Grid24 from '../../../components/UI/Grid24';

function DialogSimularQuitacao({ texto, setOpenDialogSimularQuitacao }) {
  return (
    <>
      <Grid24 style={{ display: 'flex', flexDirection: 'column' }}>

        <TextField
          style={{ height: '285px' }}
          name="texto"
          defaultValue={texto}
          id="outlined-multiline-static"
          rows={15}
          multiline
          disabled
          InputProps={{
            style: { fontSize: '13px', height: '285px' },
          }}
          sx={{
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#000000',
            },
          }}
        />
      </Grid24>
      <Grid24>
        <div>
          <Typography
            component="pre"
          >
            * Para efetuar a quitação, utilize as funcionalidades de Acordo para realizar uma nova negociação.
          </Typography>
        </div>
      </Grid24>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '22px' }}>
        <Button
          onClick={() => setOpenDialogSimularQuitacao(false)}
        >
          OK
        </Button>
      </div>

    </>
  );
}


export default DialogSimularQuitacao;
